import { ResponseService } from './../services/response.service';
import { UserService } from './../services/user.service';
import { User } from './../interfaces/user.model';
import { NotificationsService } from 'angular2-notifications';
import { ApiService } from './../services/api.service';
import { FormGroup, FormControl } from '@angular/forms';
import { MessagesService } from './../services/messages.service';
import { ActivatedRoute } from '@angular/router';
import { Component, OnInit, AfterViewInit } from '@angular/core';
import { LocalStorageService } from './../services/local-storage.service';
import { DateService } from '../services/date.service';

@Component({
  selector: 'app-message-thread',
  templateUrl: './message-thread.component.html',
})
export class MessageThreadComponent implements OnInit, AfterViewInit {

  user: User;
  conversationID = '';

  messagesStatuses = {};
  ticket = {};
  articles = {};

  messagesThreadLoading: Boolean = true;
  company_id = null;
  replyForm: FormGroup;
  selectedFiles: Array<any>;

  constructor(
    private apiService: ApiService,
    private userService: UserService,
    private messagesService: MessagesService,
    private router: ActivatedRoute,
    private notificationsService: NotificationsService,
    private responseService: ResponseService,
    private localStorageService: LocalStorageService,
    private dateService: DateService,
  ) {
    this.selectedFiles = [];
    this.company_id = this.localStorageService.get('company');
    this.replyForm = new FormGroup({
      message: new FormControl('', []),
      company_id: new FormControl(this.company_id, []),
      uploaded_files: new FormControl(''),

    });
  }

  ngAfterViewInit() {
    this.messagesThreadLoading = true;
  }

  ngOnInit() {
    this.userService.getUser().subscribe(
      (user: User) => {
        this.user = user;
      }
    );

    this.router.params.subscribe(params => {
      this.conversationID = params['id'];
      this.getConversation();
    });

    this.messagesStatuses = this.messagesService.states;
  }

  getConversation() {
    this.messagesService.getConversation(this.conversationID, this.localStorageService.get('company')).subscribe(
      (data) => {
        this.ticket = data['ticket'];
        this.articles = data['articles'];
        this.messagesThreadLoading = false;
      }
    );
  }

  sendReply() {
    this.replyForm.get('uploaded_files').setValue(this.selectedFiles);

    this.apiService.post('/conversations/' + this.conversationID + '/reply', this.replyForm.value).subscribe(
      (response) => {
        this.responseService.success(false, response);
        this.getConversation();
        this.selectedFiles = [];
        this.replyForm.reset();
        this.replyForm.get('company_id').setValue(this.company_id);
        this.notificationsService.success('Sukces!', 'Wiadomość została wysłana');
      },
      (error) => {
        var messages = {
          'message': 'Treść wiadomości nie może być pusta.',
          'uploaded_files': 'Wielkość pliku jest zbyt duża lub niezgodny typ'
        }
        
        for (var key in error) {
          var message;
          if ((message = messages[key]) !== undefined) {
            this.notificationsService.error('Ups', message);
          }
          if(/^uploaded_files/.test(key)){
            message = messages['uploaded_files'];
            this.notificationsService.error('Ups', message);
          }
        };
          
        if (message === undefined) {
          this.notificationsService.error('Ups', 'Wystąpił nieznany błąd podczas wysyłania wiadomości. Prosimy odświeżyć stronę. Jeżeli problem się powtórzy prosimy o kontakt z BOK Data Space.');
        }
      }
    );
  }

  onFileChange(event) {
    let reader = new FileReader();
    if(event.target.files && event.target.files.length > 0) {
        let file = event.target.files[0];
        reader.readAsDataURL(file);
        reader.onload = () => {
  
          this.selectedFiles.push({
            filename: file.name,
            filetype: file.type,
            file_extension: file.name.split('.')[file.name.split('.').length-1],
            value: reader.result.split(',')[1]
          });
        };
      
    }
  }

  removeFile(file) {
    this.selectedFiles.splice(file, 1);
  }
}



// WEBPACK FOOTER //
// ./src/app/messages/message-thread.component.ts